export const environment = {
  production: false,
  apiBaseUrl: 'https://develop.sf24.api.smartfit100.com/v1',
  wsBaseUrl: 'wss://develop.sf24.api.smartfit100.com/ws',
  shopId: 'tshop00041480',
  timeout: 5000,
  btPostUrl: 'https://www.acctrans-reg.jp/rtex/ar/nj3XA53q/',
  mulPayTokenUrl: 'https://stg.static.mul-pay.jp/ext/js/token.js',
};
